var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.537 26.108h8.924V9.892h-8.924v16.216Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.105 18c0-3.29 1.523-6.22 3.895-8.108a10.083 10.083 0 0 0-6.303-2.204C6.066 7.688 1.5 12.305 1.5 18c0 5.695 4.565 10.313 10.197 10.313 2.38 0 4.568-.824 6.303-2.205A10.336 10.336 0 0 1 14.105 18Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.182 24.39v-.4h-.104l-.118.275-.12-.275h-.103v.4h.073v-.302l.112.26h.075l.112-.26v.302h.073Zm-.655 0v-.332h.133v-.067h-.337v.067h.132v.332h.072ZM34.5 18c0 5.695-4.566 10.313-10.197 10.313-2.38 0-4.568-.824-6.303-2.205A10.336 10.336 0 0 0 21.895 18c0-3.29-1.523-6.22-3.895-8.108a10.082 10.082 0 0 1 6.303-2.204C29.934 7.688 34.5 12.305 34.5 18Z",
    fill: "#F79E1B"
  })));
};
export default SvgMastercard;